import { useEffect } from "react";
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import { useState } from "react";

function App() {

  // Get the state of the json file
  var [data, setData] = useState(null)

  useEffect(() => {

    let api_type;
    let api_swagger;

    let service = window.location.hostname.split(".")[2]
    let environment = window.location.hostname.split(".")[1]

    if (window.location.hostname == "docs.homhero.com.au") {
      service = "homhero"
      environment = "prod"
    }

    document.title = `${service.charAt(0).toUpperCase()}${service.slice(1)} ${environment} API`
  
    if (service == "homhero") {
      if (window.location.hostname.includes("internal")) {
        api_type = "Private"
        api_swagger = "/swagger-private.json"
      } else {
        api_type = "Public"
        api_swagger = "/swagger-public.json"
      }

    } else if (service == "hompay") {
      api_type = ""
      api_swagger = `https://payments.${environment}.hompay.com.au/v1/api-docs`
    }

    // fetch the base json file
    fetch(api_swagger)
    .then(response => response.json())
    .then(data => {

      // Depending on the hostname context change some parameters
      if (environment == "staging") {
        data.info.title = `${service.charAt(0).toUpperCase()}${service.slice(1)} ${api_type} Staging API`
        data.host = `api.${environment}.${service}.com.au`

      } else if (environment == "dev") {
        data.info.title = `${service.charAt(0).toUpperCase()}${service.slice(1)} ${api_type} Dev API`
        data.host = `api.${environment}.${service}.com.au`

      } else {
        data.info.title = `${service.charAt(0).toUpperCase()}${service.slice(1)} ${api_type} API`
        data.host = `api.${service}.com.au`
      }

      setData(data)
    })
  }, [])

  if (data) { 
    return (
      <SwaggerUI spec={data} />
    )
  }
}

export default App;
